import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { IEquipment } from 'src/app/models/equipment.model';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-equipment',
  templateUrl: './equipment.component.html',
  styleUrls: ['./equipment.component.scss']
})
export class EquipmentComponent implements OnInit {
  private timer: any;
  private currentIndex: number;

  @HostBinding('class') hostClasses = 'columns';
  @Input() equipment: IEquipment[];
  @Input() showCalifications: boolean;
  selectedEquipment: IEquipment;

  constructor() { }

  ngOnInit(): void {
    this.currentIndex = 0;
    this.selectedEquipment= this.equipment[0];
    this.setTimer();
  }

  setTimer() {
    this.timer = setTimeout(() => {
      this.currentIndex ++;

      if (this.currentIndex < this.equipment.length) {
        this.selectedEquipment = this.equipment[this.currentIndex];
      } else {
        this.currentIndex = 0;
      }

      this.setTimer();
    }, 3000);
  }

  selectItem(index: number): void {
    clearTimeout(this.timer);
    this.currentIndex = index;
    this.selectedEquipment = this.equipment[this.currentIndex];
    this.setTimer();
  }
}
